module.exports = __webpack_public_path__ + "img/google-g-logo.edd0e34f.svg";